import React, { useState } from 'react'
import { Document, Page, Text, View,Image,StyleSheet, Font  } from '@react-pdf/renderer'
import { calcularEdad, fechaActual, HoraActual } from '../../../hooks/UseDate'
//import { postInformacionEmpresa } from '../../../services/PaginaRuta';
import logo from '../../../images/Logo-G-Ocho.png'

// Registro de fuente personalizada
Font.register({
  family: 'Open Sans',
  fonts: [
    { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf' },
    { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf', fontWeight: 600 }
  ]
})

const styles = StyleSheet.create({
  page: {
    padding: 20,
  },
  row: {
    flexDirection: 'row',
    marginBottom: 5,
  },
  nameColumn: {
    flexGrow: 1,
    fontWeight: 'bold',
    fontSize: 9,
  },
  priceColumn: {
    width: 50,
    textAlign: 'right',
    fontSize: 9,
  },
  bold:{
    fontFamily: 'Open Sans',
    fontWeight: 600
  },
  image: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: 60, 
    height: 60, 
    margin: '10px',
  },
});

//dataPDF,dataUser,dataHonorario,valorTotalLiquidacionQx

const ModalAntesDescargarPDFLiquidacionQx = ({dataPrecios, dataProcedimientos,dataPDF,dataUser, dataPreciosPDF,totalPrecioProcedimiento,dataAnestesiologo,informacionEmpresa}) => {
//   const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
//   const [informacionEmpresa,setinformacionEmpresa]=useState([])
//   const datosEmpresa={
//     "EMPCOD":usuarioInfo.Empresa,
//     "MCDpto":usuarioInfo.Sede,
// }
  // postInformacionEmpresa(datosEmpresa).then((res)=>{
  //   setinformacionEmpresa(res.data[0])
  // })
  const formatearNumeroConPuntos=(numero)=> {
    if (numero === undefined || numero === null) {
      //console.error('Número no definido:', numero);
      return "0";  // o cualquier valor por defecto que desees
  }
    return numero.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}
  return (
    <Document>            

             <Page size='A4' style={{padding: '40px' }}>
              <View>
              <Image style={styles.image} src={logo} />
              <Text style={{ fontSize: 10,textAlign: 'center',padding: '5px',fontFamily: 'Open Sans',fontWeight: 900}}>{informacionEmpresa.EmpRazSoc}</Text>            
            <Text style={{ fontSize: 10,textAlign: 'center',padding: '5px',fontFamily: 'Open Sans',fontWeight: 900}}>{informacionEmpresa.EmpNit} </Text>
                <Text style={{textAlign: 'center', fontSize: 10, lineHeight: 2,fontFamily: 'Open Sans',fontWeight: 900 }}>LIQUIDACIÓN DE QX POR DOCUMENTO</Text>
                <Text style={{lineHeight: 1,fontSize: 12, padding: '5px',fontFamily: 'Open Sans',fontWeight: 900}}>DATOS PERSONALES</Text>
              </View>
              <View style={{ width: '100%', height: 'auto', borderWidth: 1, borderColor: 'black',padding: '10px' }}>
                <Text style={{ fontSize: 10, lineHeight: 2 }}><Text style={styles.bold}>Nro Cirugia:</Text> {dataUser.ProCirCod}    <Text style={styles.bold}>Identificacion:</Text> {dataUser.MPTDoc}    {dataUser.MPCedu}    <Text style={styles.bold}>Número Ingreso:</Text> {dataUser.ProCtvIn}   <Text style={styles.bold}>Edad:</Text> {calcularEdad(dataUser.MPFchN.split(' ')[0])} AÑOS </Text>                
                <Text style={{ fontSize: 10, lineHeight: 2 }}><Text style={styles.bold}>Nombre:</Text> {dataUser.MPNOMC?dataUser.MPNOMC.trim():null}             <Text style={styles.bold}>Habitación:</Text> {dataPDF.TFcCodCam} <br/></Text>
                <Text style={{ fontSize: 10 }}><Text style={styles.bold}>Tipo Servicio:</Text> {dataPDF.ClaPro === '1'?'AMBULATORIO': (dataPDF.ClaPro === '2'?'HOSPITALIZACION':(dataPDF.ClaPro === '3'?'URGENCIAS':null))} </Text>
              </View>
              <View>
                <Text style={{lineHeight: 1,fontSize: 12, padding: '5px',fontFamily: 'Open Sans',fontWeight: 900}}>DATOS RESPONSABLE</Text>
              </View>
              <View style={{ width: '100%', height: 'auto', borderWidth: 1, borderColor: 'black',padding: '10px'  }}>
                <Text style={{ fontSize: 10, lineHeight: 2 }}><Text style={styles.bold}>Responsable:</Text> {dataPDF.EmpDsc}            <Text style={styles.bold}>Nit/Cedula:</Text> {dataPDF.MENNIT}</Text>
                <Text style={{ fontSize: 10, lineHeight: 2 }}><Text style={styles.bold}>Nombre:</Text> {dataPDF.MENOMB}      <Text style={styles.bold}>Tarifa:</Text> {dataPDF.PTDesc.trim()}</Text>
                <Text style={{ fontSize: 10 }}><Text style={styles.bold}>Autorización Nro:</Text></Text>
              </View>
              <View>
                <Text style={{lineHeight: 1,fontSize: 12, padding: '5px',fontFamily: 'Open Sans',fontWeight: 900}}>DATOS CIRUGIA</Text>
              </View>
              <View style={{ width: '100%', height: 'auto', borderWidth: 1, borderColor: 'black',padding: '10px'  }}>
                <Text style={{ fontSize: 10, lineHeight: 2}}><Text style={styles.bold}>Fecha:</Text> {fechaActual()}   <Text style={styles.bold}>Festiva S/N:</Text>    <Text style={styles.bold}>Entrada Quirofano:</Text> {dataPDF.ProFec.split(' ')[0]} {dataPDF.ProHorI}   <Text style={styles.bold}>Salida Quirofano:</Text> {dataPDF.ProFecF.split(' ')[0]} {dataPDF.ProHorF}</Text>
                <Text style={{ fontSize: 10, lineHeight: 2 }}><Text style={styles.bold}>Inicio Cirugia:</Text> {dataPDF.FECINICIR}     <Text style={styles.bold}>Termino Cirugia:</Text> {dataPDF.FECFINCIR}    <Text style={styles.bold}>Electiva/Urgente:</Text> {dataPDF.ForLiqcar}     </Text>
                <Text style={{ fontSize: 10 }}><Text style={styles.bold}>Herida Quirurgica:</Text> {dataPDF.TipHer === '1'? 'Limpia': (dataPDF.TipHer === '2'? 'Limpia Contaminada': (dataPDF.TipHer === '3'? 'Contaminada': (dataPDF.TipHer === '4'? 'Sucia': null)))}   <Text style={styles.bold}>Quirofano:</Text> {dataPDF.ProCons}</Text>
              </View>
              <View>
                <Text style={{lineHeight: 1,fontSize: 12, padding: '5px',fontFamily: 'Open Sans',fontWeight: 900}}>DATOS ANESTESIA</Text>
              </View>
              <View style={{ width: '100%', height: 'auto', borderWidth: 1, borderColor: 'black',padding: '10px'  }}>
                <Text style={{ fontSize: 10, lineHeight: 2}}><Text style={styles.bold}>Tipo Anestasia:</Text>    <Text style={styles.bold}>Anestesiologo:</Text> {dataAnestesiologo.nombreMedicoEs}    <Text style={styles.bold}>Hora Entrada: </Text>  <Text style={styles.bold}>Hora Salida:</Text></Text>                
              </View>  
              {
                dataPreciosPDF.map((item, index) => (
                  item.tipoHojaFact === 'F' ? (
                    <View key={index}>
                      <Text style={{ fontSize: 9, marginTop: '5px'}}>
                        <Text style={styles.bold}>Codigo Prodecimiento: </Text>{item.CrgCod}  <Text style={styles.bold}>Nombre Procedimiento: </Text>{item.PrNomb.trim()}  
                      </Text>
                      <Text style={{ fontSize: 9,}}>
                        <Text style={styles.bold}>Orden:</Text>{item.orden}    <Text style={styles.bold}>UVR:</Text>{item.CantidadUVR}    {item.precios[0].DescripcionFormaLiquidacion}    {item.ProMCDpto}     {item.agrupadorProcedimiento} 
                      </Text>
                      <Text style={{ fontSize: 9, textAlign: 'right',padding: '2px'  }}>
                        <Text style={styles.bold}>Total Procedimiento:</Text>  ${formatearNumeroConPuntos(item.precioProcedimiento)}
                      </Text>
                      {item.precios.map((subItem, subIndex) => (
                        subItem.tipoHojaFact === 'F' ? (
                          <View key={subIndex} style={styles.row}>
                            <Text style={styles.nameColumn}>{subItem.DescripcionHonorario}</Text>
                            <Text style={styles.priceColumn}>${formatearNumeroConPuntos(subItem.ValorHonorarioImprLiqCir)}</Text>
                            <Text style={styles.priceColumn}>{subItem.PorcOrden}%</Text>
                          </View>
                        ) : 
                        null
                      ))}
                      
                      <hr style={{ color: 'black', backgroundColor: 'black', height: 1  }} />
                    </View>
                  ) : 
                  null
                ))
              }
              <Text style={{ fontSize: 12, textAlign: 'center', padding: '10px'  }}>     <Text style={styles.bold}>TOTAL TODOS LOS PROCEDIMIENTOS: ${formatearNumeroConPuntos(totalPrecioProcedimiento)}</Text></Text>
              <Text style={{ fontSize: 12, textAlign: 'center', padding: '10px'  }}>{fechaActual()}       <Text style={styles.bold}>* * * FIN DEL REPORTE * * *</Text>      {HoraActual()}</Text>
               
            </Page>               
            
    </Document>        
     
  )
}

export default ModalAntesDescargarPDFLiquidacionQx